export default "/packs/images/true-adventure-portal@2x~698c3af37a0852c3990e5b3b2281344e.png";